import React, { FC } from "react";

import { LabelProps } from "./model";

import { LabelWrapper } from "./styles";

const Label: FC<LabelProps> = ({
  fontFamily = "montserrat",
  fontSize = "s-10",
  fontWeight = "w-400",
  color = "scarpaGray800",
  as = "span",
  children,
  classLabel,
}) => {
  return (
    <LabelWrapper
      as={as}
      size={fontSize}
      colorLabel={color}
      family={fontFamily}
      weight={fontWeight}
      className={classLabel}
    >
      {children}
    </LabelWrapper>
  );
};

Label.propTypes = {};

export default Label;
